lg-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1em;
  height: 1em;

  svg {
    width: 1em;
    height: 1em;

    path {
      fill: currentColor;
    }
  }
}
